import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { logout } from "../actions/userActions";
import { mobileNavMenu } from "./data";

const Header = ({ backgroundColor }) => {
  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.userDetails);
  const { user } = userDetails;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [isLoggedIn, setLoggedIn] = useState(false);

  const [mobileNavView, setMobileNavView] = useState(false);


  const displayMobileNav = () => {
    setMobileNavView(true);
    document.body.style.overflow = 'hidden'
  };
  
  const hideMobileNav = () => {
    setMobileNavView(false);
    document.body.style.overflow = 'auto'
  };

  const logoutHandler = () => {
    dispatch(logout());
    setLoggedIn(false);
  };

  useEffect(() => {
    if (userInfo) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, [user, userInfo, isLoggedIn]);

  return (
    <div className={`${backgroundColor || "bg-night-blue"}`}>
      <header className="indicador container flex items-center justify-between pb-10 pt-7">
        <Link to="/">
          <img
            className="w-28"
            src={require("../assets/images/logo-vrc.png")}
            alt="vrc-logo"
          />
        </Link>
        <div
          className="grid z-40 text-night-blue rounded-full place-items-center fixed right-4 sm:right-10 bg-creamy-beige w-12 aspect-square"
          onClick={displayMobileNav}
        >
          <i
            className="iconify"
            data-icon="iconamoon:menu-burger-horizontal-bold"
          />
        </div>
        <div
          className={`fixed z-50 inset-0 transition-all duration-500 ${mobileNavView ? 'bg-black/30' : 'bg-transparent pointer-events-none'}`}
          onClick={hideMobileNav}
        >
          <nav
            className={ `bg-night-blue h-full px-2 absolute right-0 top-0 w-4/5 transition-all duration-500
              ${mobileNavView ? 'translate-x-0' : 'translate-x-full'}`
            }
          >
            <ul className="container">
              <i
                className="iconify text-creamy-beige my-9 ml-auto"
                data-icon="ph:x-bold"
              />
              {isLoggedIn && userInfo ? (
                <>
                  <span className="nav-divider"></span>
                  <li
                    className="text-creamy-beige font-oswald font-semibold py-4 uppercase"
                    onClick={hideMobileNav}
                  >
                    <Link to="/catalogue">listings catalogue</Link>
                  </li>
                  <li
                    className="text-creamy-beige font-oswald font-semibold py-4 uppercase"
                    onClick={hideMobileNav}
                  >
                    <Link
                      to={userInfo.type === "admin" ? "/admin" : "/account"}
                    >
                      dashboard
                    </Link>
                  </li>
                  <li
                    className="text-creamy-beige font-oswald font-semibold py-4 uppercase"
                    onClick={hideMobileNav}
                  >
                    <Link to="/messages">chat</Link>
                  </li>
                  {userInfo.type === "teacher" && (
                    <li
                      className="text-creamy-beige font-oswald font-semibold py-4 uppercase"
                      onClick={hideMobileNav}
                    >
                      <Link to={`/mybookings`}>my bookings</Link>
                    </li>
                  )}
                  {userInfo.type !== "admin" && (
                    <li
                      className="text-creamy-beige font-oswald font-semibold py-4 uppercase"
                      onClick={hideMobileNav}
                    >
                      <Link to={`/${userInfo.type}/${userInfo._id}`}>
                        my profile
                      </Link>
                    </li>
                  )}

                  <li
                    onClick={() => {
                      logoutHandler();
                      hideMobileNav();
                    }}
                    className="text-creamy-beige font-oswald font-semibold py-4 uppercase"
                  >
                    <Link to={`/account`}>logout</Link>
                  </li>
                </>
              ) : (
                <li
                  className="py-3 bg-canton-jadesheen hover:bg-yellow text-night-blue mb-16 text-center w-full font-oswald font-semibold uppercase"
                  onClick={hideMobileNav}
                >
                  <Link to="/login">login</Link>
                </li>
              )}
              {mobileNavMenu.map((ele, index) => (
                <li
                  key={index}
                  className="text-creamy-beige font-oswald font-semibold py-4 uppercase"
                  onClick={hideMobileNav}
                >
                  <Link to={`/${ele}`}>{ele.split("-").join(" ")}</Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
